module.exports = __webpack_public_path__ + "img/ys-2.5a47c82a.svg";